export type TDDStatus = "spec-ready" | "in-development" | "planned" | "deployed";

export interface TDDListItem {
  id: string;
  title: string;
  status: TDDStatus;
  summary: string;
}

export const tddList: TDDListItem[] = [
  {
    id: "TDD-1",
    title: "Protocol Architecture",
    status: "deployed",
    summary:
      "A modular on-chain protocol for deploying structured crypto assets with explicit market mechanics and omnichain reach.",
  },
  {
    id: "TDD-2",
    title: "Arbitrage and Yield Capture",
    status: "deployed",
    summary:
      "On-chain mechanics that formalize how divergence between protocol fair value and market price is recognized and expressed.",
  },
  {
    id: "TDD-3",
    title: "Liquidity Management",
    status: "planned",
    summary: "Inventory, vault routing, and treasury netting policy definitions.",
  },
  {
    id: "TDD-4",
    title: "Market Transformations",
    status: "planned",
    summary: "Market Transformations",
  },
  {
    id: "TDD-5",
    title: "Simulation Engine",
    status: "deployed",
    summary: "Historical replay system that validates every parameter before capital deployment.",
  },
];

